<script lang="ts" setup>
import Skeleton from "./Skeleton.vue";
</script>
<template>
  <div class="space-y-4">
    <Skeleton class="h-32 w-full" />
    <Skeleton class="h-16 w-full" />
    <Skeleton class="h-32 w-full" />
  </div>
</template>
